import {
  Input,
  Component,
} from '@angular/core';
import { ConfirmationModalOptions } from './confirmation-modal.interfaces';
import { FrontendModalService } from '@tablesready/frontend-modal';

export interface ConfirmationModalResult<T> {
  response: T;
  instance: ConfirmationModalComponent;
}

@Component({
  selector: 'tr-confirmation-modal',
  templateUrl: './confirmation-modal.component.html',
  styleUrls: ['./confirmation-modal.component.scss'],
  standalone: false,
})
export class ConfirmationModalComponent {
  @Input() options: ConfirmationModalOptions;

  constructor(private readonly modalController: FrontendModalService) {}

  confirm(): void {
    this.modalController.dismiss({
      response: true,
      instance: this,
    });
  }

  close(): void {
    this.modalController.dismiss({
      response: false,
      instance: this,
    });
  }
}
